import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Modals
import NewPriceModal from '../../shared/modals/NewPriceModal'

// Actions
import { getPriceLists, updatePriceList, createPriceListFrom } from '../../actions/priceModel'
import { triggerPopup } from '../../actions/backdrop'
import { getCustomer, getCustomers } from '../../actions/customers'

// import styles
import './prices.scss'

// import components
import Header from '../../shared/components/Header'
// import LeftMenu from '../../shared/components/Menus/LeftMenu'
import LeftMenuContent from '../../shared/components/Menus/LeftMenu/Content'

// Elements
import SideMenu from '../../shared/elements/sideMenu'
import SideMenuHeader from '../../shared/elements/sideMenuHeader'
import SideMenuItem from '../../shared/elements/sideMenuItem'
import SideMenuCustomItem from '../../shared/elements/sideMenuCustomItem'
import { OrderDepartmentIcons } from '../../shared/elements/icons'

import { setPageTitle, setPageTitleExtra } from '../../actions/common'

// Views
import Salescar from './Salescar'
import Extras from './Extras'
import Estimation from './Estimation'
import ReportDiscounts from './Discounts/ReportDiscounts'
import Discounts from './Discounts'
import AgreementDetails from '../PriceAgreements/Agreements/Details'
import Insurance from '../PriceAgreements/Agreements/Insurance'

// Utils
import { hasAccess, hasSubscriptionPermission } from '../../utils/auth'
import { translation, enumtranslate } from '../../utils/helpers'
import CloseButton from '../../shared/elements/closeButton'
import Button from '../../shared/elements/button'

class Prices extends Component {

  constructor (props) {
    super(props)
    this.state = {
      customer: null,
      showNewPriceModal: false,
      valid: [
        {
          name: 'salescar',
          access: [2, 3]
        },
        {
          name: 'private',
          access: [2, 3]
        },
        {
          name: 'warranty',
          access: [2, 3]
        },
        {
          name: 'addon',
          access: [2, 3],
          subscriptionValue: 30
        },
        {
          name: 'discounts',
          access: [3, 7],
          subscriptionValue: 10
        },
        {
          name: 'extras',
          access: [2, 3, 4, 7],
          subscriptionValue: 30
        },
        {
          name: 'services',
          access: [4],
          subscriptionValue: 30
        },
        {
          name: 'estimation',
          access: [2, 3, 7]
        }
      ],
      list: [],
      activeItem: {},
      fetched: false,
      customerName: null,
      hasForsiCustomerNr: false,
      search: '',
      includeInactive: false
      // discounts: []
    }
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.createNewPricemodel = this.createNewPricemodel.bind(this)
    this.showNewPriceModal = this.showNewPriceModal.bind(this)
    this.createNew = this.createNew.bind(this)
    this.onShouldUpdate = this.onShouldUpdate.bind(this)
    this.searchList = this.searchList.bind(this)
    this.filterList = this.filterList.bind(this)
  }

  componentDidMount () {
    if (this.props.route.customer && typeof this.props.params.customerID !== 'undefined') {
      this.props.getCustomers(0, parseInt(this.props.params.customerID))
    }
    if (this.props.route.customer) {
      this.getCustomer()
    }
    if (!this.hasAccessToPage()) {
      this.props.router.push('/prices')
    } else {
      this.getPriceLists()
    }
  }

  componentWillUpdate (nextProps) {
    if (this.props.route.customer !== nextProps.route.customer || this.props.route.partners !== nextProps.route.partners) {
      this.setState({
        list: [],
        activeItem: {},
        fetched: false
        // customerName: 'Test'
      }, () => {
        this.getPriceLists()
      })
    }
  }

  componentDidUpdate () {
    if (!this.hasAccessToPage()) {
      this.props.router.push('/prices')
    }
  }

  hasAccessToPage () {
    let valid = true
    let found = false
    if (typeof this.props.params.type !== 'undefined') {
      this.state.valid.map((val, key) => {
        if (val.name === this.props.params.type) {
          found = true
          if (!hasAccess(val.access, this.props.auth.user.UserType)) {
            valid = false
          }
          if (valid === true && val.subscriptionValue !== undefined) {
            if (!hasSubscriptionPermission(this.props.auth, val.subscriptionValue)) valid = false
          }
        }
      })
      if ((!found || !valid) && hasAccess([3, 7], this.props.auth.user.UserType)) valid = true
    }
    return valid
  }

  getCustomer () {
    if (typeof this.props.params.customerID !== 'undefined') {
      this.props.getCustomer(this.props.params.customerID).then((res) => {
        this.setState({
          customer: res.data,
          hasForsiCustomerNr: parseInt(res.data.ForsiCustomerNumber) > 0
        })
      })
    }
  }

  getPriceLists () {
    let props = this.props
    let id = (props.route.customer) ? props.params.customerID : 0
    let workProviderId = (props.route.partners) ? props.params.partnerID : 0
    if (hasAccess([4], props.auth.user.UserType)) id = props.auth.user.CustomerId
    return props.getPriceLists(id, workProviderId).then((res) => {
      this.setState({
        list: res.data,
        fetched: true
      })
      return res
    }, () => {
      console.log('Err fetching price lists data')
      return null
    })
  }

  createPriceListFrom (parentId) {
    let data = {
      ParentPriceModelId: parentId,
      CustomerId: this.props.params.customerID
    }
    return this.props.createPriceListFrom(data).then((res) => {
      return res
    })
  }

  onShouldUpdate () {
    // Redirect
    if (this.props.route.partners) {
      this.props.router.push('/partners/' + this.props.params.partnerID + '/prices')
    } else if (this.props.route.customer) {
      this.props.router.push('/customers/' + this.props.params.customerID + '/prices')
    } else {
      this.props.router.push('/prices')
    }
    this.getPriceLists().then(() => {
      // Toastr
      // window.toastr.success(translation('13444'), translation('13424'))
    }, () => {
      // Toastr
      window.toastr.error(translation('2018'), translation('216'))
    })
  }

  searchList (e) {
    if (e.target.name === 'SearchText') {
      this.setState({
        search: e.target.value
      })
    }
    if (e.target.name === 'Inactive') {
      this.setState({
        includeInactive: e.target.checked
      })
    }
  }

  filterList (key) {
    if (key.Name === undefined || key.Name === null) return true
    if ((!this.state.includeInactive ? key.Active : true)) {
      return true
    }
    return false
  }

  leftMenu () {
    // if (this.state.list.length === 0) return null
    // Create
    if (this.props.params.type === 'create') {
      const onAdd = () => {
        // console.log('Create pricelist from: ', this.state.activeItem)

        this.createPriceListFrom(this.state.activeItem.PriceModelId).then((res) => {
          setTimeout(() => {
            this.getPriceLists().then(() => {
              // Toastr
              // window.toastr.success(translation('13444'), translation('13424'))
              // Redirect
              if (this.props.route.partners) {
                this.props.router.push('/partners/' + this.props.params.partnerID + '/prices/' + res.data.PriceModelId)
              } else if (this.props.route.customer) {
                this.props.router.push('/customers/' + this.props.params.customerID + '/prices/' + res.data.PriceModelId)
              } else {
                this.props.router.push('/prices/' + res.data.PriceModelId)
              }
            }, () => {
              // Toastr
              window.toastr.error(translation('2018'), translation('216'))
              // Redirect
              if (this.props.route.partners) {
                this.props.router.push('/partners/' + this.props.params.partnerID + '/prices')
              } else if (this.props.route.customer) {
                this.props.router.push('/customers/' + this.props.params.customerID + '/prices')
              } else {
                this.props.router.push('/prices')
              }
            })
          }, 0)
        })
      }
      const cancelAdd = () => {
        if (this.props.route.partners) {
          this.props.router.push('/partners/' + this.props.params.partnerID + '/prices')
        } else if (this.props.route.customer) {
          this.props.router.push('/customers/' + this.props.params.customerID + '/prices')
        } else {
          this.props.router.push('/prices')
        }
      }

      return [
        <SideMenuCustomItem key='0' isFixed>
          <Button onClick={onAdd} labelText={translation('1208')} />
        </SideMenuCustomItem>,
        <SideMenuCustomItem key='1' isFixed>
          <Button style='secondary' onClick={cancelAdd} labelText={translation('570')} />
        </SideMenuCustomItem>
      ]
    }
    // Render item
    const renderItem = (val, key) => {
      // console.log('renderItem val/key', val, key)
      let isTitle = false
      // Name + Link
      let name = val.Name
      let brand = val.Brand

      // if (val.Active === false && !this.state.includeInactive) return

      let link = '/prices/' + val.PriceModelId
      if (name === null) {
        if (val.PriceType !== 4) {
          if (!hasAccess([2, 3, 7], this.props.auth.user.UserType)) return null
        }
        if ([4, 6, 8].indexOf(val.PriceType) !== -1 && !hasSubscriptionPermission(this.props.auth, 30)) return null
        if ([-10].indexOf(val.PriceType) !== -1 && !hasSubscriptionPermission(this.props.auth, 10)) return null
        if (val.Department === 1 && val.PriceType === 5) return null
        switch (val.PriceType) {
          case 4:
            name = translation('2224')
            // if (hasAccess([4], this.props.auth.user.UserType)) name = translation('13375')
            link = '/prices/extras/' + val.Department
            if (val.IsServices !== undefined && val.IsServices === true) {
              if (this.props.auth.user.DepartmentType !== 0) return null
              name = translation('13375')
              link = '/prices/services/' + val.Department
            }
            isTitle = true
            break
          case 5:
            name = translation('13363')
            link = '/prices/estimation/' + val.Department
            isTitle = true
            break
          case -10:
            if (val.Department !== 1) {
              name = translation('18316')
              isTitle = true
              link = '/prices/discounts/' + val.Department
            }
            break
          // case 4:
          //   name = translation('2224')
          //   // if (hasAccess([4], this.props.auth.user.UserType)) name = translation('13375')
          //   link = '/prices/extras'
          //   if (val.IsServices !== undefined && val.IsServices === true) {
          //     name = translation('13375')
          //     link = '/prices/services'
          //   }
          //   classNameList = 'headerItem'
          //   break
          // case 5:
          //   name = translation('13363')
          //   link = '/prices/estimation'
          //   classNameList = 'headerItem'
          //   break
          // case -10:
          //   name = translation('1197')
          //   link = '/prices/discounts'
          //   classNameList = 'headerItem'
          //   break
        }
      } else {
        if (!hasAccess([2, 6], this.props.auth.user.UserType)) {
          if (!hasAccess([3, 4, 7], this.props.auth.user.UserType)) return null
          // classNameList = 'subChild'
        }
      }

      // Customer links
      if (this.props.route.customer) {
        link = '/customers/' + this.props.params.customerID + link
      }
      // Partners links
      if (this.props.route.partners) {
        link = '/partners/' + this.props.params.partnerID + link
      }

      let text = name
      if (!hasAccess([6], this.props.auth.user.UserType)) {
        if (val.IsWorkprovider === true && brand !== null) {
          text += ' (' + brand + '/' + val.WorkProviderName + ')'
        } else if (brand !== null) {
          text += ' (' + brand + ')'
        } else if (val.IsWorkprovider) {
          text += ' (' + val.WorkProviderName + ')'
        }
      }

      // Return
      return (
        <SideMenuItem
          label={text}
          renderLabel={(label, className, activeClassName) => (
            <Link to={link} className={className} activeClassName={activeClassName}>
              {label}
            </Link>
          )}
          inactive={!val.Active}
          isTitle={isTitle}
          key={key}
        />
      )
    }

    let groups = {
      Undefined: [],
      Insurance: [],
      Sales: [],
      Warranty: [],
      Private: [],
      Other: [],
      Complaint: [],
      Addon: [],
      Discounts: [],
      Extra: [],
      Estimation: [],
      UnGrouped: []
    }
    let groupsBody = {
      Undefined: [],
      Insurance: [],
      Sales: [],
      Warranty: [],
      Private: [],
      Other: [],
      Complaint: [],
      Addon: [],
      Discounts: [],
      Extra: [],
      Estimation: [],
      UnGrouped: []
    }
    const getGroup = (item) => {
      let group = groups
      if (item.Department === 1) group = groupsBody
      return group
    }
    let paintCount = 0
    let bodyCount = 0
    for (let i = 0; i < this.state.list.length; i++) {
      let item = this.state.list[i]
      if ([-10].indexOf(item.PriceType) !== -1 && !hasSubscriptionPermission(this.props.auth, 10)) continue
      let foundGroup = getGroup(item)
      // console.log('leftMenu foundGroup', foundGroup)
      if (foundGroup === groups) paintCount++
      if (foundGroup === groupsBody) bodyCount++
      switch (item.PriceType) {
        case -1: // Undefined
          foundGroup.Undefined.push(item)
          break
        case 0: // Other
          foundGroup.Other.push(item)
          break
        case 1: // Salescar
          foundGroup.Sales.push(item)
          break
        case 2: // Private
          foundGroup.Private.push(item)
          break
        case 3: // Warranty
          foundGroup.Warranty.push(item)
          break
        case 4: // Extra
          foundGroup.UnGrouped.push(item) // only bodyshop
          if (hasAccess([4], this.props.auth.user.UserType)) {
            let servicesItem = { ...item }
            servicesItem.IsServices = true
            foundGroup.UnGrouped.push(servicesItem)
          }

          break
        case 5: // Estimation
          if (item.Name !== null) {
            foundGroup.Insurance.push(item)
          } else {
            foundGroup.UnGrouped.push(item) // only bodyshop
          }
          break
        case 6: // Complaint
          foundGroup.Complaint.push(item)
          break
        case 8:
          foundGroup.Addon.push(item)
          break
        case -10: // Discounts
          // console.log('menu discount case item', item)
          // if (item.Department === 1) {
          foundGroup.Discounts.push(item)
          // } else {
          //   foundGroup.UnGrouped.push(item)
          // }
          break
      }
    }
    const renderGroup = (val, key) => {
      if (val.length === 0) return null
      let groupTitle = translation(key)

      if (key === 'UnGrouped') {
        return val.map(renderItem)
      } else if (key === 'Discounts') {
        const discountPaintLabel = 18316
        const discountBodyLabel = 1197
        return (
          <SideMenuItem label={translation(this.props.auth.departmentType === 0 ? discountPaintLabel : discountBodyLabel)} isTitle key={key}>
            {this.props.route.customer && this.state.customer && this.state.customer.Discounts && this.state.customer.Discounts.map(renderDiscountList)}
          </SideMenuItem>
        )
      } else {
        return (
          <SideMenuItem label={groupTitle} isTitle key={key}>
            {val.map(renderItem)}
          </SideMenuItem>
        )
      }
    }

    const renderDiscountList = (val) => {
      if (val.IsAddonPrice && val.OrderType === 1) {
        const renderLink = (label, className, activeClassName) => (
          <Link to={'/customers/' + this.props.params.customerID + '/prices/discounts/' + val.Department + '/Addon'} className={className} activeClassName={activeClassName}>
            {label}
          </Link>
        )

        return <SideMenuItem label={translation('1396')} renderLabel={renderLink} key='addon' />
      } else {
        let text = translation(enumtranslate('OrderTypes', val.OrderType))
        if (val.OrderType === 1) text = translation('70')
        if (val.OrderType === 4) text = translation('2263')

        const renderLink = (label, className, activeClassName) => {
          return (
            <Link to={'/customers/' + this.props.params.customerID + '/prices/discounts/' + val.Department + '/' + val.OrderType} className={className} activeClassName={activeClassName}>
              {label}
            </Link>
          )
        }

        return <SideMenuItem label={text} renderLabel={renderLink} key={val.OrderType} />
      }
    }

    const renderGroups = (count, header, groups, src, bodyDiscounts) => {
      if (count === 0) return null

      return (
        <SideMenuHeader label={header} icon={src} key={header}>
          {renderGroup(groups['Undefined'], '2036')}
          {renderGroup(groups['Insurance'], '13360')}
          {renderGroup(groups['Sales'], '71')}
          {renderGroup(groups['Warranty'], '13361')}
          {renderGroup(groups['Private'], '785')}
          {renderGroup(groups['Other'], '73')}
          {renderGroup(groups['Complaint'], '301')}
          {renderGroup(groups['Addon'], '1396')}
          {this.props.route.customer && renderGroup(groups['Discounts'], 'Discounts')}
          {renderGroup(groups['UnGrouped'], 'UnGrouped')}
        </SideMenuHeader>
      )
    }

    return [
      renderGroups(paintCount, translation('161'), groups, OrderDepartmentIcons.Paint, false),
      renderGroups(bodyCount, translation('788'), groupsBody, OrderDepartmentIcons.Body, true)
    ]
  }

  renderHeaderTitle () {
    const { customer } = this.state
    // if (customer === null || customer.CompanyName === null || !this.props.route.customer) return translation('1172')
    // return translation('1172') + ' - ' + customer.CompanyName
    if (customer === null || customer.CompanyName === null || !this.props.route.customer) return null
    return customer.CompanyName
  }

  findPriceModelId (type, id) {
    let item = null
    this.state.list.map((val, key) => {
      if (typeof id === 'undefined') {
        if (val.PriceType === type && val.Name === null) {
          item = val
        }
      } else {
        if (val.PriceModelId === id) {
          item = val
        }
      }
    })
    return item
  }
  findDepartmentPriceModelId (type, department) {
    let item = null
    this.state.list.map((val, key) => {
      if (typeof department === 'undefined') {
        if (val.PriceType === type && val.Name === null) {
          item = val
        }
      } else {
        if (val.PriceType === type && val.Name === null && val.Department === department) {
          item = val
        }
      }
    })
    return item
  }
  renderView () {
    let item = null
    switch (this.props.params.type) {
      case 'salescar':
        item = this.findPriceModelId(1)
        return <Salescar router={this.props.router} onShouldUpdate={this.onShouldUpdate} item={item} customer={this.props.route.customer} partners={this.props.route.partners} getPriceLists={this.getPriceLists.bind(this)} />
      case 'warranty':
        item = this.findPriceModelId(3)
        return <Salescar router={this.props.router} onShouldUpdate={this.onShouldUpdate} item={item} customer={this.props.route.customer} partners={this.props.route.partners} getPriceLists={this.getPriceLists.bind(this)} />
      case 'private':
        item = this.findPriceModelId(2)
        return <Salescar router={this.props.router} onShouldUpdate={this.onShouldUpdate} item={item} customer={this.props.route.customer} partners={this.props.route.partners} getPriceLists={this.getPriceLists.bind(this)} />
      case 'addon':
        item = this.findPriceModelId(8)
        return <Salescar router={this.props.router} onShouldUpdate={this.onShouldUpdate} item={item} customer={this.props.route.customer} partners={this.props.route.partners} getPriceLists={this.getPriceLists.bind(this)} />
      case 'extras':
        item = this.findDepartmentPriceModelId(4, parseInt(this.props.params.value))
        if (item !== null) {
          return <Extras router={this.props.router} item={item} customer={this.props.route.customer} showExtras showServices={false} />
        }
        return null
      case 'services':
        item = this.findPriceModelId(4)
        return <Extras router={this.props.router} item={item} customer={this.props.route.customer} showExtras={false} showServices />
      case 'estimation':
        item = this.findPriceModelId(5)
        return item && <Estimation router={this.props.router} item={item} customer={this.props.route.customer} /> || null
      case 'discounts':
        let dep = parseInt(this.props.params.value)
        item = this.findDepartmentPriceModelId(-10, dep)
        // console.log('renderView discounts item', item)
        if (item) {
          let renderKickback = this.props.auth.user.DepartmentType === 1 && !this.state.hasForsiCustomerNr
          let renderReportDiscounts = [1, 2, 3, 6].indexOf(parseInt(this.props.params.separateType)) > -1
          return (
            <div>
              {renderReportDiscounts && <ReportDiscounts router={this.props.router} item={item} customer={this.props.route.customer} customerId={parseInt(this.props.params.customerID)} hasKickback={renderKickback} type={this.props.params.separateType} isBodyShop={dep === 1} department={dep} />}
              <Discounts router={this.props.router} item={item} customer={this.props.route.customer} customerId={parseInt(this.props.params.customerID)} hasKickback={renderKickback} type={this.props.params.separateType} isBodyShop={dep === 1} />
            </div>
          )
        }
        return null
      case 'create':
        return <Salescar router={this.props.router} onShouldUpdate={this.onShouldUpdate} creating item={this.state.activeItem} customer={this.props.route.customer} partners={this.props.route.partners} getPriceLists={this.getPriceLists.bind(this)} />
      default:
        if (!isNaN(this.props.params.type)) {
          item = this.findPriceModelId(0, parseInt(this.props.params.type))
          if (item !== null) {
            let pricetype = item.PriceType
            let isPriceModelType = pricetype !== 5 && pricetype !== 6 && pricetype !== 0
            let isInsuranceType = pricetype === 5 || pricetype === 6 || pricetype === 0
            if (item.CustomerGroupId === 0) {
              return <Salescar router={this.props.router} onShouldUpdate={this.onShouldUpdate} item={item} customer={this.props.route.customer} partners={this.props.route.partners} getPriceLists={this.getPriceLists.bind(this)} />
            }
            if (item.CustomerGroupId > 0 && isPriceModelType && !item.UseEstimationList) {
              return <AgreementDetails router={this.props.router} onShouldUpdate={this.onShouldUpdate} item={item} isMain customer={this.props.route.customer} partners={this.props.route.partners} getPriceLists={this.getPriceLists.bind(this)} />
            }
            if (item.CustomerGroupId > 0 && (isInsuranceType || item.UseEstimationList)) {
              return <Insurance ref='view'
                router={this.props.router}
                selectedTabIndex={this.state.selectedTabIndex}
                onShouldUpdate={this.onShouldUpdate}
                selectedCustomerId={-1}
                isMain
                item={item}
                pricemodels={this.state.list}
                agreementId={this.state.activeItem.PriceModelId}
                getPriceLists={this.getPriceLists.bind(this)} />
              // return <AgreementDetails onShouldUpdate={this.onShouldUpdate} item={item} customer={this.props.route.customer} partners={this.props.route.partners} getPriceLists={this.getPriceLists.bind(this)} />
            }
          }
        }
        return null
    }
  }

  createNewPricemodel () {
    let data = {
      PriceModelId: 0,
      PriceType: 1,
      Name: 'New'
    }
    if (this.props.route.partners) {
      data.WorkProviderId = this.props.params.partnerID
      data.CustomerSelectionType = 1
    }
    this.props.updatePriceList(data).then((res) => {
      this.setState({
        activeItem: res.data
      })
      if (this.props.route.partners) {
        this.props.router.push('/partners/' + this.props.params.partnerID + '/prices/create')
      } else {
        this.props.router.push('/prices/create')
      }
    }, () => {
      // Toastr
      window.toastr.error(translation('13482'), translation('216'))
    })
  }

  showNewPriceModal () {
    if (hasAccess([6], this.props.auth.user.UserType)) {  // Show new price model popup for chain, shop and shop/customer
      if (this.props.route.partners) {
        this.createNew({
          PriceModelId: 0,
          PriceType: 1
        })
      } else {
        this.createNew({
          PriceModelId: 0,
          PriceType: -1
        })
      }
    } else {
      this.props.triggerPopup(!this.state.showNewPriceModal)
      this.setState({
        showNewPriceModal: !this.state.showNewPriceModal
      })
    }
  }

  createNew (data) {
    if (data.PriceModelId === 0) {
      let create = {
        PriceModelId: 0,
        PriceType: (typeof data.PriceType !== 'undefined') ? data.PriceType : -1,
        Name: 'New',
        Department: (typeof data.Department !== 'undefined') ? data.Department : 0
      }
      if (this.props.route.partners) {
        create.WorkProviderId = this.props.params.partnerID
        create.CustomerSelectionType = 1
      }
      this.props.updatePriceList(create).then((res) => {
        this.setState({
          activeItem: {
            Name: res.data.Name,
            PriceModelId: res.data.PriceModelId,
            PriceType: res.data.PriceType,
            Department: res.data.Department
          }
        }, () => {
          setTimeout(() => {
            this.getPriceLists().then(() => {
              // Toastr
              // window.toastr.success(translation('13444'), translation('13424'))
              // Redirect
              if (this.props.route.partners) {
                this.props.router.push('/partners/' + this.props.params.partnerID + '/prices/' + this.state.activeItem.PriceModelId)
              } else if (this.props.route.customer) {
                this.props.router.push('/customers/' + this.props.params.customerID + '/prices/' + this.state.activeItem.PriceModelId)
              } else {
                this.props.router.push('/prices/' + this.state.activeItem.PriceModelId)
              }
            }, () => {
              // Toastr
              window.toastr.error(translation('2018'), translation('216'))
              // Redirect
              if (this.props.route.partners) {
                this.props.router.push('/partners/' + this.props.params.partnerID + '/prices')
              } else if (this.props.route.customer) {
                this.props.router.push('/customers/' + this.props.params.customerID + '/prices')
              } else {
                this.props.router.push('/prices')
              }
            })
          }, 0)
        })
        // this.props.router.push('/prices/' + res.data.PriceModelId)
      }, () => {
        // Toastr
        window.toastr.error(translation('13482'), translation('216'))
      })
    } else {
      this.setState({
        activeItem: data
      })
      if (this.props.route.partners) {
        this.props.router.push('/partners/' + this.props.params.partnerID + '/prices/create')
      } else if (this.props.route.customer) {
        this.props.router.push('/customers/' + this.props.params.customerID + '/prices/create')
      } else {
        this.props.router.push('/prices/create')
      }
    }
  }

  headerButtonsRight () {
    // if (this.props.route.customer) return null
    if (!hasAccess([2, 3, 6, 7], this.props.auth.user.UserType)) return null
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    if (this.state.customer && !this.state.customer.IsOwnedByShop) return null
    return (
      <div>
        <Button spacing={0} size='m' labelText={translation(1797)} ariaText={translation('2052')} onClick={this.showNewPriceModal} />
        <NewPriceModal
          onCreate={this.createNew}
          customer={this.props.route.customer}
          partners={this.props.route.partners}
          activeCustomerId={this.props.params.customerID}
          show={this.state.showNewPriceModal}
          onClose={this.showNewPriceModal} />
      </div>
    )
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null
    let headerButtonsGoBack
    headerButtonsGoBack = (router, t) => {
      const goBack = () => {
        this.props.router.replace({
          pathname: '/customers',
          query: {
            customerId: this.props.params.customerID
          }
        })
      }
      if (!this.props.route.customer) return null
      return <CloseButton key='back_close' ariaText={t('2060')} onClick={goBack} />
    }

    let isCreateView = this.props.params.type === 'create'
    return (
      <div className='prices__screen'>
        <Header router={this.props.router} pageTitleExtra={this.renderHeaderTitle()} renderRight={this.headerButtonsRight} showBack={this.props.route.customer} headerButtonsGoBack={headerButtonsGoBack} />

        <SideMenu disableFilter={isCreateView}>
          {this.leftMenu()}
        </SideMenu>

        <LeftMenuContent className='prices__screen--inner'>
          {this.renderView()}
        </LeftMenuContent>
      </div>
    )
  }

}

Prices.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    customers: state.common.customers,
    pageTitle: state.common.pageTitle,
    activeCustomer: state.common.activeCustomer
  }
}

export default connect(mapStateToProps, {
  getPriceLists,
  updatePriceList,
  createPriceListFrom,
  triggerPopup,
  getCustomer,
  getCustomers,
  setPageTitle,
  setPageTitleExtra
})(Prices)



// WEBPACK FOOTER //
// ./src/app/pages/Prices/index.js